import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe que converter um valor em bytes para um valor em Kb, Mb, Gb, etc.
 *
 */
@Pipe({
    name: 'bytesConverter',
})
export class BytesConverterPipe implements PipeTransform {
    transform(value: string | undefined | null, decimals: number = 2): string {
        if (!value) return '0 Bytes';

        const bytes = parseFloat(value);

        if (!+bytes) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = [
            'Bytes',
            'KiB',
            'MiB',
            'GiB',
            'TiB',
            'PiB',
            'EiB',
            'ZiB',
            'YiB',
        ];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }
}
